export default "__VITE_ASSET__Dm1CQTu$__"